import { Store } from 'vuex';

import { AppState } from '@/store';
import { Logger } from '../logger';
import { AxiosInstance, AxiosResponse } from 'axios';
import { ApiService } from '../api/api.service';
import { FeedbackPostBody, FeedbackResponse } from '@/models/feedback';
import { MUTATIONS } from '@/store/order';
import { AnalyticsService } from '../analytics/analytics.service';

export interface FeedbackService {
  postFeedback(feedback: FeedbackPostBody): Promise<FeedbackResponse>;
  getFeedback(orderId: string): Promise<FeedbackResponse>;
  setFeedback(feedback: FeedbackResponse | null): void;
}

const FEEDBACK_BASE_ROUTE = '/customerfeedback/v1';

export class AppFeedbackService extends ApiService implements FeedbackService {
  constructor(store: Store<AppState>, httpClient: AxiosInstance, logger: Logger, protected analytics: AnalyticsService) {
    super(store, httpClient, logger, analytics);
  }

  async postFeedback(feedback: FeedbackPostBody): Promise<FeedbackResponse> {
    return await this.httpClient.post(`${FEEDBACK_BASE_ROUTE}/feedback/order`, feedback)
      .then((r: AxiosResponse<FeedbackResponse>) => r.data)
      .catch(e => this.logAndThrowApiError('postFeedback', e));
  }

  async getFeedback(orderId: string): Promise<FeedbackResponse> {
    return await this.httpClient.get(`${FEEDBACK_BASE_ROUTE}/feedback/order/${orderId}`)
      .then((r: AxiosResponse<FeedbackResponse>) => r.data)
      .catch(e => this.logAndThrowApiError('getFeedback', e));
  }

  setFeedback(feedback: FeedbackResponse | null): void {
    this.store.commit(MUTATIONS.SET_FEEDBACK, feedback);
  }
}
